import { useTranslation } from "react-i18next";
import { AnchoredPopover, FoodsIcon } from "@foodpilot/foods";
import { ColumnPositionPopover, ColumnPositionPopoverProps } from "src/components/Popover/ColumnPositionPopover";
import type { TableAction } from "./GridTableActions";

type ColumnsSettings = Omit<ColumnPositionPopoverProps, "onClose">;

export const useColumnsTableAction = (columns: ColumnsSettings): TableAction => {
    const { t } = useTranslation();
    const { columnConfig, columnOrder, setColumnOrder, toggleVisibility } = columns;

    return {
        icon: <FoodsIcon icon="columns" size={2} />,
        label: t("grid.table_actions.customize_columns", "Customize columns"),
        renderPopover: (anchor, onClose) => (
            <AnchoredPopover variant="headless" anchorPosition="rightside" anchor={anchor} open onClose={onClose}>
                <ColumnPositionPopover
                    onClose={onClose}
                    columnConfig={columnConfig}
                    columnOrder={columnOrder}
                    setColumnOrder={setColumnOrder}
                    toggleVisibility={toggleVisibility}
                />
            </AnchoredPopover>
        ),
    };
};
